import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import { css } from "@emotion/css";
import cn from "classnames";
import CircularProgress from "@mui/material/CircularProgress";

type Props = {
  hideLoaderContent: boolean;
  isSearching: boolean;
  children: ReactNode;
};

const loadedContentStyles = css`
  position: relative;
  transition: all 230ms linear;

  .hidden {
    opacity: 0;
    user-select: none;
    pointer-events: none;
  }

  .circular-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -30%);
  }
`;

export const FormWithLoadedContent = observer((props: Props) => {
  const { hideLoaderContent, isSearching } = props;
  return (
    <div className={loadedContentStyles}>
      {isSearching && (
        <div className="circular-loader">
          <CircularProgress color="secondary" />
        </div>
      )}
      <div className={cn({ hidden: hideLoaderContent })}>{props.children}</div>
    </div>
  );
});
